// @flow

import React from "react";

import { NewValue, ValueList } from "../styles";
import NameOrEmail from "src/containers/user/NameOrEmail";
import GroupMembersModal from "../GroupMembersModal";
import { getFilteredUserNotification } from "src/utils/checklist";

import type { UsersAndGroups } from "src/types";

type Props = {
  newValue: Array<UsersAndGroups>,
  oldValue: Array<UsersAndGroups>
};

const NewUserValue = ({ newValue, oldValue }: Props) => {
  const filteredUserNotifications = getFilteredUserNotification(
    newValue,
    oldValue
  );
  return (
    <>
      {filteredUserNotifications.length > 0 && (
        <NewValue>
          <ValueList>
            {filteredUserNotifications.map(value => {
              if (value.type === "user")
                return <NameOrEmail uid={value.uid} key={value.uid} />;
              else return value.id && <GroupMembersModal id={value.id} />;
            })}
          </ValueList>
        </NewValue>
      )}
    </>
  );
};

export default NewUserValue;
